import * as Yup from "yup";

export interface SelectOption {
  value: string;
  label: string;
}

export const statusOptions: SelectOption[] = [
  { label: "Active", value: "ACTIVE" },
  { label: "Inactive", value: "INACTIVE" },
  { label: "Repair", value: "REPAIR" },
  { label: "Rental", value: "RENTAL" },
  { label: "Out Of Service", value: "OUT OF SERVICE" }
];

export interface EquipmentListModel {
  unitNumber: string | null;
  equipmentType: string | null;
  assetDescriptor: string | null;
  make: string | null;
  model: string | null;
  year: string | null;
  vin: string | null;
  licensePlate: string | null;
  registrationDate: string | null;
  dotInspectionDate: string | null;
  domicileTerminal: string | null;
  location: string | null;
  garageCity: string | null;
  garageState: string | null;
  status: string | null;
  disposition: string | null;
  utilizationPercent: string | null;
  dwellTimeDays: string | null;
  leaseType: string | null;
  vendor: string | null;
  productLine: string | null;
  termMonths: string | null;
  annualAllowance: string | null;
  annualRateMeasurement: string | null;
  monthlyRate: string | null;
  size: string | null;
  accessory: string | null;
  serialNumber: string | null;
  inServiceDate: string | null;
  expirationDate: string | null;
  fuelType: string | null;
  registrationDocUrl: string | null;
  dotCertificateUrl: string | null;
  notes: string | null;
}


export interface EquipmentFormModel {
  unitNumber: string | null;
  equipmentType: string | null;
  assetDescriptor: string | null;
  make: string | null;
  model: string | null;
  year: string | null;
  vin: string | null;
  licensePlate: string | null;
  registrationDate: string | null;
  dotInspectionDate: string | null;
  domicileTerminal: string | null;
  location: string | null;
  garageCity: string | null;
  garageState: string | null;
  status: string | null;
  disposition: string | null;
  utilizationPercent: string | null;
  dwellTimeDays: string | null;
  leaseType: string | null;
  vendor: string | null;
  productLine: string | null;
  termMonths: string | null;
  annualAllowance: string | null;
  annualRateMeasurement: string | null;
  monthlyRate: string | null;
  size: string | null;
  accessory: string | null;
  serialNumber: string | null;
  inServiceDate: string | null;
  expirationDate: string | null;
  fuelType: string | null;
  registrationDocUrl: string | null;
  dotCertificateUrl: string | null;
  notes: string | null;
}

export interface EquipmentDetailModel {
  id: string | null;
  unitNumber: string | null;
  equipmentType: string | null;
  assetDescriptor: string | null;
  make: string | null;
  model: string | null;
  year: string | null;
  vin: string | null;
  licensePlate: string | null;
  registrationDate: string | null;
  dotInspectionDate: string | null;
  domicileTerminal: string | null;
  location: string | null;
  garageCity: string | null;
  garageState: string | null;
  status: string | null;
  disposition: string | null;
  utilizationPercent: string | null;
  dwellTimeDays: string | null;
  leaseType: string | null;
  vendor: string | null;
  productLine: string | null;
  termMonths: string | null;
  annualAllowance: string | null;
  annualRateMeasurement: string | null;
  monthlyRate: string | null;
  size: string | null;
  accessory: string | null;
  serialNumber: string | null;
  inServiceDate: string | null;
  expirationDate: string | null;
  fuelType: string | null;
  registrationDocUrl: string | null;
  dotCertificateUrl: string | null;
  notes: string | null;
}

export const getEquipmentInfoValidation = (): Yup.ObjectSchema<EquipmentFormModel> => {
  return Yup.object().shape({
    equipmentType: Yup.string()
      .required('Equipment Type is required'),
    assetDescriptor: Yup.string()
      .required('Asset Descripto is required')
  }).defined();
};
